import * as React from 'react';
import { observer, inject } from 'mobx-react';
import { IAppOnlyStore } from 'stores/AllStores';
import { PricingRequestListItem } from '.';
import { IPricingRequest } from 'common/interfaces/pricing';

// Styles
const s = require('./PendingPricingRequestsList.css');

// Component
@inject('store')
@observer
export class PendingPricingRequestsList extends React.Component<IAppOnlyStore, {}> {
    constructor(props) {
        super(props);
    }

    public render() {
        const { pricingRequests } = this.props.store.pricingRequest;

        return (
            <div className={s.list}>
                {(pricingRequests.map((request, i) => {
                    return (
                        <PricingRequestListItem
                            key={'request-' + request.id}
                            onClick={this.openPricingRequest}
                            request={request}
                        />
                    );
                }))}
            </div>
        );
    }

    private openPricingRequest = (request: IPricingRequest) => {
        this.props.store.pricingRequest.fetchSinglePricingRequest(request.id);
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/pricing/PendingPricingRequestsList.tsx